import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Card, Box, Button, Typography } from '@mui/material';
import { usePageTitle } from '../../common/hooks/usePageTitle';
import { captilizeString } from '../../common/functionUtils';
import { getMemberIDCard, setMemberIDClean } from '../../../redux/memberAccounts/action';
import Label from '../type/Label';
import { analyticsTrackEvent } from '../../../utils/analytics/analytics-utils';
import { Download } from '@mui/icons-material';
import { getLanguageCookies } from '../../../utils/content-utils';

const IdCardMemberCard = () => {
  const dispatch = useDispatch();
  const [memberList, setMemberList] = useState([]);
  const [enrollmentsList, setEnrollmentsList] = useState([]);
  const memberAccounts = useSelector(
    state => state?.memberAccounts?.memberAccountsDetails
  );
  const selfEnrollmentsFromStore = useSelector(state => state?.enrollments?.enrollmentsDetails);
  const dependentEnrollments = useSelector(state => state?.dependentEnrollments);
  const medicalCard = useSelector(state => state?.memberAccounts?.memberIdCards);
  const tenantInfo = useSelector(state => state?.tenant?.tenantInfo);
  usePageTitle('ID Cards');
  const language = getLanguageCookies();

  useEffect(() => {
    if (medicalCard) {
      const btnTextForPrint = language === 'es' ? 'Imprimir': 'Print';
      const btnTextForDownLoad = language === 'es' ? 'Descargar' : 'Download';
      const img = `<title>Member ID Card</title>
      <div>
      <br />
      <div style="width: 600px; text-align: right" id="medicalCardId">
        <button style="padding: 10px 20px; border: 1px solid #B40F87; background: #ffffff; color: #B40F87; border-radius: 3px; corsor: pointer; text-decoration: none; margin:0 5px; outline:none" title="Click here to print" onclick="printHandler()">${btnTextForPrint}</button>
        <a style="padding: 10px 20px; border: 1px solid #B40F87; background: #ffffff; color: #B40F87; border-radius: 3px; corsor: pointer; text-decoration: none;" title="Click here to download" download="DCHP-ID-card.png" href="data:image/png;base64,${medicalCard}">${btnTextForDownLoad}</a></div><br /><br /><div>
        <img src="data:image/png;base64,${medicalCard}" height="800px" alt="medicalcard"/>
        </div>
        <br /><br /></div>
      <script>
      function printHandler() {
        const image = '<img src="data:image/png;base64,${medicalCard}" height="800px" id="duplicateCard" alt="medicalcard"/>'
        document.querySelector("#medicalCardId").style.display="none";
        window.print();
        document.querySelector("#medicalCardId").style.display="block";
      }

      </script>`;
      let element = window.open();
      element.document.write(img);
      dispatch(setMemberIDClean());
    }
  }, [medicalCard]);

  useEffect(() => {
    if (memberAccounts?.self || memberAccounts?.dependents)
      memberAccounts?.self ?
        setMemberList([{ ...memberAccounts.self }, ...memberAccounts.dependents,]) :
        setMemberList([null, ...memberAccounts.dependents]);
  }, [memberAccounts]);

  useEffect(() => {
    dependentEnrollments.length ?
      setEnrollmentsList([selfEnrollmentsFromStore, ...dependentEnrollments]) :
      setEnrollmentsList([selfEnrollmentsFromStore]);
  }, [dependentEnrollments, selfEnrollmentsFromStore]);

  const handleViewId = (groupId, subscriberId, subscriberSuffix) => {
    const { self: selfFromStore } = memberAccounts;
    let memberAccountHeader = '';
    if (selfFromStore || memberAccounts?.dependents.length) {
      memberAccountHeader = `${groupId}-${subscriberId}-${subscriberSuffix}`;
    }
    dispatch(getMemberIDCard(memberAccountHeader, localStorage.getItem('tenantHandle')));
  };

  switch (tenantInfo['tenantHandle']) {
    case 'dchp': return <Box className='viewIdCardContainer'>
      <Card className='viewIdCards'>
        {memberList.length === 0 || !memberList[0]?.firstName ? <Typography variant='h6'>There are no ID Cards to display.</Typography> :
          memberList.map((member, index) => <Box key={index} className='viewIdCard'>
            <Typography variant='body1' className='viewIdCardText'>{`${captilizeString(member?.firstName)} ${captilizeString(member?.lastName)}`}</Typography>
            <Button variant='outlined' color='primary'
              id={'btn-' + member?.firstName}
              disabled={!enrollmentsList[index]?.hasMedicalInsurance}
              onClick={e => {
                e.preventDefault();
                handleViewId(member?.groupId, member?.subscriberId, member?.subscriberSuffix);
                analyticsTrackEvent('idcards_IDdownload_clicked', { eventCategory: 'Plan Benefits Pathing' });
              }}>
               <Download color='secondary'/>&nbsp;&nbsp;<Label id="memberIdCard"></Label>
              </Button>
          </Box>)}

      </Card>
    </Box>;

    default: return null;
  }

};

export default IdCardMemberCard;
